import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RequiredAsteriskDirective } from './directives/required-asterisk.directive';

@NgModule({
  imports: [CommonModule, RequiredAsteriskDirective],
  exports: [RequiredAsteriskDirective]
})
export class FormModule {}
